import { render, staticRenderFns } from "./create-new-nudge.vue?vue&type=template&id=10a43438&"
import script from "./create-new-nudge.ts?vue&type=script&lang=ts&"
export * from "./create-new-nudge.ts?vue&type=script&lang=ts&"
import style0 from "./create-new-nudge.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports